import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import graduate from '../images/cuet-img/a graduate.jpg'
import audi from '../images/cuet-img/audi.jpg'
import vcBuilding from '../images/cuet-img/vc building.jpg'
import vc from '../images/cuet-img/vc.jpg'
import banner2 from '../images/cuet-img/banner-2.jpg'
import logo from '../images/cuet-img/cuetlogo.png'
import incubator from '../images/cuet-img/incubator4.jpg'
import webiner from '../images/cuet-img/webiner.jpg'
import webiner2 from '../images/cuet-img/webiner2.jpg'
import mujib100 from '../images/mujib100.png'


const Home = () => {
   
    return (
        <Wrapper>
            <div className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={banner2} alt="..." />
                        <div className="overlay">
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Welcome to the center of excellence</h2>
                                <p>visit us to explore more about us</p>
                                <Link to='/about' className="btn btn-outline-light fw-bolder">Explore cuet</Link>
                            </div>
                        </div>

                    </div>
                    <div className="carousel-item">
                        <img src={vc} alt="..." />
                        <div className="overlay">
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Education is the architecture of the soul</h2>
                                <p>view our curriculam</p>
                                <Link to='/academics' className="btn btn-outline-light fw-bolder">View now</Link>
                            </div>

                        </div>

                    </div>
                    <div className="carousel-item">
                        <img src={graduate} alt="..." />
                        <div className="overlay">
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Apply now for the better future tomorrow</h2>
                                <p>Join with us and be a part of the success</p>
                                <Link to='/apply' className="btn btn-outline-light fw-bolder">Apply now</Link>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <section className="news py-4 mx-auto text-center">
                <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='90%' viewBox='0 0 900 600'><rect fill='#ffffff' width='900' height='600' /><g fill-opacity='1'><path fill='#000' d='M306.9 210.2c-1.2-22.8-13.5-42.7-40.8-41.1c-18.3 1.1-35.9 3.6-47.5 20.1c-5.2 7.4-10.6 15.6-11.4 24.9c-0.5 5.8 0.2 12 1.2 17.7c9 49.6 85.3 46.7 96.4 0.2C306.6 224.9 307.3 217.4 306.9 210.2z' /><path fill='#000000' d='M137.2 481.3c-13.2-9.9-31.2-13.3-48.5-3.2c-12.6 7.3-19.1 17.4-21.1 28.2c-0.7 2.4-1.2 4.7-1.5 7c-8.2 35.4 33.7 78.9 72.6 48.6C167.6 539.3 164.4 501.6 137.2 481.3z' /><g fill='#000000' ><path d='M547.9 588.3c-7.1-34.2-61.6-52.7-87.5-16.9c-11.2 11.3-12.7 26.3-7.6 39.7c1.8 7.5 5.5 13.9 10.4 19.1c19.4 20.3 53.4 26.2 72.8 1.9C545.9 619.7 553.9 604.2 547.9 588.3z' /><path d='M547.9-11.7c-7.1-34.2-61.6-52.7-87.5-16.9c-11.2 11.3-12.7 26.3-7.6 39.7c1.8 7.5 5.5 13.9 10.4 19.1c19.4 20.3 53.4 26.2 72.8 1.9C545.9 19.7 553.9 4.2 547.9-11.7z' /></g><path fill='#000000' d='M849.7 498c-22.3 1.3-43.2 7.5-52.7 29.5c-3.3 7.7-7.3 15.7-7 24.3c2 55.6 86.1 63.4 98.8 10.1C890.6 554.6 877.3 496.4 849.7 498z' /><path fill='#000000' d='M762 291.1c-8.2-6.1-19.1-1.9-27.3 2.2c-7.4 3.7-14.4 8.2-21.6 12.1c-6.6 3.6-13.7 7-19.8 11.5c-18.3 13.5-2.5 45.1 10.6 56.4c17 14.6 41.6 15.9 59.6 2.1C794.1 351.8 790.7 312.4 762 291.1z' /><path fill='#000000' d='M863.3 170.3c-4.5-15.7-17.9-28.8-33.4-34.4c-16.2-5.8-38.4-2.9-51.8 8.1c-14.9 12.2-14.5 31.7-11.4 49c9.6 53.9 84.3 47.7 97-1.3C865.6 184.4 865.3 177.1 863.3 170.3z' /><path fill='#000000' d='M598.4 86.1c-10.2 15.5-9.3 34.2-0.9 50.4c2.6 5 6.2 9.5 10.4 13.2c14.2 12.6 35.5 17.1 53.2 9.5c14.3-6.1 23.9-19.8 26.7-34.7C707.4 75.6 629.7 38.5 598.4 86.1z' /><path fill='#000000' d='M509.8 413.3c-17.3 22.6-11.8 59 17.5 75.3c22.6 12.6 52.2 1.7 63.8-20.9c21.4-42-9.2-85-56.5-71C523.8 399.9 515.6 405.8 509.8 413.3z' /><path fill='#000000' d='M607.4 232.3c-0.5-0.4-1-0.8-1.4-1.2c-16.5-12.8-30.2-22.1-50.3-8.4c-15.5 10.6-29 30.3-31.4 49.1c-4.2 33.6 30.6 46.9 58.6 40.6C619.6 304.2 640.6 259.5 607.4 232.3z' /><path fill='#000000' d='M410.6 95c-36.5 1.3-74.1 41.8-43.1 74.3c19.8 20.9 54.4 20.7 74.6 0.5c20.5-20.4 18.4-53.1-6.9-68.6C427.7 96.6 419.2 94.7 410.6 95z' /><path fill='#000000' d='M291.3 23c-0.1-0.1-0.1-0.1-0.2-0.2c-14.2-16.9-38.3-25.6-61.4-12.3c-13.5 7.8-20.5 18.7-22.7 30.2c-5.7 18 1.5 34.2 14.2 44.8c15.4 16.8 40.3 24.1 64.2 5.5c9.6-7.4 15-16.3 17.2-25.4C308.6 48.8 302.7 33.6 291.3 23z' /><path fill='#000000' d='M419.1 440.6c-16.9-14.5-41.8-21.5-61.7-9.5c-18.3 11.1-1 100.1 32.2 93.5c23.8-4.7 45.3-22.4 48.1-44.3C439.6 466.1 431.5 451.3 419.1 440.6z' /><path fill='#000000' d='M127 227c-12-4.3-25.4-2.1-38.7 11.4C71 255.9 61.4 286.1 80.4 306c21.3 22.3 86.9 27.5 89.6-14.9c0.5-8.9-2.7-17.9-6.5-25.8C155.1 248.3 142.1 232.5 127 227z' /><path fill='#000000' d='M281.5 407.6c-0.3-0.4-0.7-0.7-1-1c-19.3-17.6-59.1-0.6-78.1 10.3c-23.8 13.7-8.2 41.1 5.4 55.8c16.3 17.6 42.7 25.2 68 5.8C291.3 466.6 295.5 422.7 281.5 407.6z' /><path fill='#000000' d='M137.9 110.2c-10.4-25.7-43.3-32.1-67-23.6C60.1 90.4 50 97.8 45.1 108.6c-21.2 47.3 44.9 81.1 78.5 51c9.5-8.5 17.3-18.9 17.4-32.4C141 120.8 139.9 115.1 137.9 110.2z' /><path fill='#000000' d='M344.3 284.7c-10 14.9-9.2 34.1-0.9 49.5c3.4 6.3 8.6 13.8 16.1 15.8c7.1 1.9 15.1 0.7 22.1-0.6c15.7-3 45.6-10.5 52.3-26.8C453.5 274.4 375.6 237.9 344.3 284.7z' /><g fill='#000000' ><path d='M-29.2 431.8c23.4 12.4 54.1 1.7 66.1-20.6c9.6-17.8 10.4-40.4-3.3-56.5c-10.5-12.4-44.2-25.8-58.5-11.3c-3 3.1-5.1 7.1-6.9 10.9C-41.1 373.2-55 418.1-29.2 431.8z' /><path d='M870.8 431.8c23.4 12.4 54.1 1.7 66.1-20.6c9.6-17.8 10.4-40.4-3.3-56.5c-10.5-12.4-44.2-25.8-58.5-11.3c-3 3.1-5.1 7.1-6.9 10.9C858.9 373.2 845 418.1 870.8 431.8z' /></g><path fill='#000' d='M671.4 460.5c-10.7 1.7-20.2 8.3-26.2 22.2c-21.5 49.5 45.4 84.9 79.4 53.3c16.3-15.2 24-31 6.5-48.1c-5.9-5.8-12.3-11-19.1-15.6C699.5 463.7 684.5 458.4 671.4 460.5z' /></g></svg>

                <div className="container">

                    <div className="heading py-4">

                        <h2>CUET NEWS</h2>
                        <h3>The latest stories from CUET</h3>
                        <i className="far fa-bookmark fa-3x"></i>
                    </div>
                    <div className="row text-start">
                        <div className="col-lg-6">
                            <Link to='/news'>
                                <img src={incubator} alt="" className='img-fluid img1' />
                                <p>The country's first university based Incubator is going to be established at the campus of Chittagong University of Engineering & Technology (CUET) ...</p>
                            </Link>
                        </div>
                        <div className="col-lg-6">
                            <div className="row ">
                                <div className="col-lg-6">
                                    <Link to='/news'>
                                        <img src={webiner} alt="" className='img-fluid' />
                                        <p>Webinar on Applications of Computational Fluid Dynamics held at CUET...</p>
                                    </Link>
                                </div>
                                <div className="col-lg-6">
                                    <Link to='/news'>
                                        <img src={webiner2} alt="" className='img-fluid' />
                                        <p>Webinar on ‘Banghabandhu : Jyotirmoy Mohanayok of Bangladesh’ by CUETTA held at CUET...</p>
                                    </Link>
                                </div>
                                <div className="col-lg-6">
                                    <Link to='/news'>
                                        <img src={audi} alt="" className='img-fluid' />
                                        <p>A new and large cafeteria is almost ready for all cuetians...</p>
                                    </Link>
                                </div>
                                <div className="col-lg-6">
                                    <Link to='/news'>
                                        <img src={mujib100} alt="" className='img-fluid' />
                                        <p>100 years celebration of Sheikh Mujibur Rahman</p>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <Link to='/news' className="btn btn-dark text-center mx-auto">more news</Link>
                    </div>

                </div>


            </section>

            <section className="events text-center text-dark py-4">

                <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 600 100'><rect fill='#ffffff' width='600' height='100' /><g stroke='#FFF' stroke-width='0' stroke-miterlimit='10' stroke-opacity='1'><circle fill='#037B79' cx='0' cy='0' r='50' /><circle fill='#92DEBA' cx='100' cy='0' r='50' /><circle fill='#FFFFD8' cx='200' cy='0' r='50' /><circle fill='#CAF2FF' cx='300' cy='0' r='50' /><circle fill='#6FCCFF' cx='400' cy='0' r='50' /><circle fill='#006EB4' cx='500' cy='0' r='50' /><circle fill='#037B79' cx='600' cy='0' r='50' /><circle cx='-50' cy='50' r='50' /><circle fill='#53ac9a' cx='50' cy='50' r='50' /><circle fill='#ceefc1' cx='150' cy='50' r='50' /><circle fill='#ffffff' cx='250' cy='50' r='50' /><circle fill='#9de0fe' cx='350' cy='50' r='50' /><circle fill='#3e9cda' cx='450' cy='50' r='50' /><circle fill='#00789c' cx='550' cy='50' r='50' /><circle cx='650' cy='50' r='50' /><circle fill='#037B79' cx='0' cy='100' r='50' /><circle fill='#92DEBA' cx='100' cy='100' r='50' /><circle fill='#FFFFD8' cx='200' cy='100' r='50' /><circle fill='#CAF2FF' cx='300' cy='100' r='50' /><circle fill='#6FCCFF' cx='400' cy='100' r='50' /><circle fill='#006EB4' cx='500' cy='100' r='50' /><circle fill='#037B79' cx='600' cy='100' r='50' /><circle cx='50' cy='150' r='50' /><circle cx='150' cy='150' r='50' /><circle cx='250' cy='150' r='50' /><circle cx='350' cy='150' r='50' /><circle cx='450' cy='150' r='50' /><circle cx='550' cy='150' r='50' /></g></svg>
                <div className="heading py-4">
                  
                    <h2>upcoming Events</h2>
                    <h3>What’s happening on campus</h3>
                    <i className="far fa-bookmark fa-3x"></i>
                </div>
                <div className="container py-4">
                    <div className="row">
                        <div className="col-lg-3">
                            <Link to='/*'>
                                <div className="card">
                                    <div className="card-body">
                                        <img src={vcBuilding} className='img-fluid' alt="" />
                                        <div className="date bg-dark text-light">
                                            <h4>sep <br /> <span>23</span></h4>
                                        </div>
                                        <div className="card-text">
                                            <h4>Event title 1</h4>
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.Voluptas, magnam?</p>
                                            <strong><i className="fas fa-clock"></i> 5: 30 PM</strong>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-3">
                            <Link to='/*'>
                                <div className="card">
                                    <div className="card-body">
                                        <img src={audi} className='img-fluid' alt="" />
                                        <div className="date bg-dark text-light">
                                            <h4>jun <br /> <span>30</span></h4>
                                        </div>
                                        <div className="card-text">
                                            <h4>Event title 2</h4>
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.Voluptas, magnam?</p>
                                            <strong><i className="fas fa-clock"></i> 7: 00 PM</strong>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-3">
                            <Link to='/*'>
                                <div className="card">
                                    <div className="card-body">
                                        <img src={graduate} className='img-fluid' alt="" />
                                        <div className="date bg-dark text-light">
                                            <h4>aug <br /> <span>01</span></h4>
                                        </div>
                                        <div className="card-text">
                                            <h4>Event title 3</h4>
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.Voluptas, magnam?</p>
                                            <strong><i className="fas fa-clock"></i> 5: 30 PM</strong>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col-lg-3">
                            <Link to='/*'>
                                <div className="card">
                                    <div className="card-body">
                                        <img src={audi} className='img-fluid' alt="" />
                                        <div className="date bg-dark text-light">
                                            <h4>oct <br /> <span>03</span></h4>
                                        </div>
                                        <div className="card-text">
                                            <h4>Event title 4</h4>
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.Voluptas, magnam?</p>
                                            <strong><i className="fas fa-clock"></i> 8: 30 PM</strong>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <Link to='/*' className="btn btn-dark mx-auto">more events</Link>
                    </div>
                </div>


            </section>

            <section className="research bg-dark text-center text-light py-4">

                <div className="container py-4">
                    <div className="heading py-4">
                        
                        <h2 className='text-uppercase py-2'>Research</h2>
                        <h3 className='text-capitalize py-2'>A culture of collaboration that drives innovative discoveries vital to our world, our health and our intellectual life</h3>
                        <i className="far fa-bookmark fa-3x"></i>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between">
                        <div>
                            <strong>18 Institutes</strong>
                            <p>cross interdisciplinary boundaries </p>
                        </div>
                        <div>
                            <strong>20 Libraries</strong>
                            <p>hold over 9.5 million volumes </p>
                        </div>
                        <div>
                            <strong>$1.93 Billion</strong>
                            <p>sponsored research budget </p>
                        </div>

                    </div>
                    <hr />

                    <Link to='/*' className="btn btn-dark mx-auto">more about</Link>
                    <h3>cuet research for a better world</h3>
                </div>
            </section>

            <section className="about text-center text-dark py-4">
                <svg xmlns='http://www.w3.org/2000/svg' width='800' height='800' viewBox='0 0 200 200'><rect fill='#ffffff' width='200' height='200' /><defs><linearGradient id='a' gradientUnits='userSpaceOnUse' x1='88' y1='88' x2='0' y2='0'><stop offset='0' stop-color='#005092' /><stop offset='1' stop-color='#007cc4' /></linearGradient><linearGradient id='b' gradientUnits='userSpaceOnUse' x1='75' y1='76' x2='168' y2='160'><stop offset='0' stop-color='#868686' /><stop offset='0.09' stop-color='#ababab' /><stop offset='0.18' stop-color='#c4c4c4' /><stop offset='0.31' stop-color='#d7d7d7' /><stop offset='0.44' stop-color='#e5e5e5' /><stop offset='0.59' stop-color='#f1f1f1' /><stop offset='0.75' stop-color='#f9f9f9' /><stop offset='1' stop-color='#FFFFFF' /></linearGradient><filter id='c' x='0' y='0' width='200%' height='200%'><feGaussianBlur in='SourceGraphic' stdDeviation='12' /></filter></defs><polygon fill='url(#a)' points='0 174 0 0 174 0' /><path fill='#000' fill-opacity='.5' filter='url(#c)' d='M121.8 174C59.2 153.1 0 174 0 174s63.5-73.8 87-94c24.4-20.9 87-80 87-80S107.9 104.4 121.8 174z' /><path fill='url(#b)' d='M142.7 142.7C59.2 142.7 0 174 0 174s42-66.3 74.9-99.3S174 0 174 0S142.7 62.6 142.7 142.7z' /></svg>
                <div className="heading py-4">
                    
                    <h2 className='text-uppercase'>About CUet</h2>
                    <h3 className='text-capitalize'>A place for learning, discovery, innovation, expression and discourse</h3>
                    <i className="far fa-bookmark fa-3x"></i>
                </div>
                <div className="container py-4">
                    <div className="container">
                        <div className="row">
                            <div className="py-4 d-flex justify-content-between">
                                <div>
                                    <p>Students</p>
                                    <h2 className="display-1">4500+</h2>
                                </div>
                                <div>
                                    <p>Faculty</p>
                                    <h2 className="display-1">200+</h2>
                                </div>
                                <div>
                                    <p>Area</p>
                                    <h2 className="display-1">171+</h2>
                                </div>

                            </div>
                        </div>
                    </div>
                    <Link to='/*' className="btn btn-dark mx-auto">more about cuet</Link>
                </div>
            </section>
        </Wrapper >
    )
}

const Wrapper = styled.article`
    .carousel-item{
        position: relative;
        .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: block;
            background: rgba(0, 0, 0, .6);
            color: #FFF;
        .carousel-caption{
                position: absolute;
                top: 20%;
                left: 0;
                width: 100%;
                height: 100%;
                display: block;

                h2{
                    font-size: 60px;
                    font-weight: 800;
                    letter-spacing: 5px;
                    padding: 20px;
                    text-transform: uppercase;
                }

                p{
                    font-size: 20px;
                    text-transform: capitalize;
                }
                a{

                }
            }

        }
        img{
            height: 500px;
            width: 100%;
            object-fit: cover;
        }
    }

    .news{
        position: relative;
        svg{
            position: absolute;
            top: 0;
            right: 0;
            z-index:-1;
            opacity: 0.1;
        }
        
        h2{
            font-weight: 800;
            letter-spacing: 3px;
            text-transform: uppercase;
            padding: 10px 0;
        }
        h3{
            text-transform: capitalize;
            padding: 15px 0;
        }
        p{
            font-size: 20px;
            padding: 5px 0;
            color:var(--clr-black);
        }
       .row{

           img{
               height: 150px;
               width: 100%;
               box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
               transition: var(--transition);
               &:hover{
                   transform: scale(1.1);
               }
               
           }
           .img1{
              height: 430px;
              width: 100%;
           }
       }

 
  
 

    }

    .events{
        position: relative;
        svg{
            position: absolute;
            z-index:-1;
            opacity: 0.2;
            left: 0;
            top: 0;
        }
        h2{
            font-weight: 800;
            letter-spacing: 3px;
            text-transform: uppercase;
            padding: 5px 0;
        }
        h3{
            text-transform: capitalize;
            padding: 5px 0;
        }

        .card-body{
            position: relative;

            img{
                height: 150px;
                width: 100%;
            }
        }
        .date{
            padding: 5px;
            margin: 5px;
            position: absolute;
            top: 35%;
            text-transform: uppercase;
            span{
                font-weight: 700;
            }
        }
        .card-text{
            margin-top: 30px;
            text-align: start;
            text-transform: capitalize;
            color: var(--clr-grey-1);
            h4{
                font-weight: 600;
                text-align: center;
                padding: 10px;
                color: var(--clr-grey-2);
            }
        }
    }

    .research{
        h2{
            font-weight: 800;
            letter-spacing: 3px;
            text-transform: uppercase;
            padding: 5px 0;
        }
        h3{
            text-transform: capitalize;
            padding: 10px 0;
        }

        strong{
            font-size: 40px;
        }
        p{
            font-size: 20px;
        }
    }
    .about{
        position: relative;
        svg{
            position: absolute;
            z-index:-1;
            opacity: 0.2;
            left: 0;
            right: 0;
            bottom: 0;
            
        }
        h2{
            font-weight: 800;
            letter-spacing: 3px;
            text-transform: uppercase;
            padding: 5px 0;
        }
        h3{
            text-transform: capitalize;
            padding: 5px 0;
        }
    }
`

export default Home
